// @flow
// @flow-runtime warn
import { useState, useCallback, useEffect, useMemo } from 'react';
import assoc from 'ramda/es/assoc';
import dissoc from 'ramda/es/dissoc';

import { api, requestsGeneral } from 'app/api';

import type { VerificationType, VerificationsRequestResult } from './types';


// $FlowFixMe
export const defaultVerifications = {};
export type VerificationStateType = {
  [solutionId: string]: Array<VerificationType>,
}

export default function useVerificationsData(solutionId: number | void): any {
  const [verifications, setVerifications] = useState<VerificationStateType>(defaultVerifications);

  /**
   *  ЗАПРОС ПРОВЕРОК ДОМАШНИХ ЗАДАНИЙ
   */

  const handleRequestVerifications = useCallback(async (solutionId_: number | void = solutionId) => {
    if (!solutionId_) return false;

    const verificationsRes: VerificationsRequestResult | null = await api.request(
      requestsGeneral.Homework_GET_verifications, {
        error: 'Не удалось получить проверки домашних заданий',
        params: [solutionId_],
      }
    );

    if (verificationsRes && verificationsRes.data) {
      setVerifications(assoc(String(solutionId_), verificationsRes.data));
      return true;
    }
    return false;
  }, [solutionId]);


  // если будет solutionId, то сработает автозагрузка
  useEffect(() => {
    handleRequestVerifications();
  }, [handleRequestVerifications]);


  const deleteVerificationBySolutionId = useCallback((sId: number) => {
    setVerifications(dissoc(String(sId)));
  }, []);


  const memoizedResult = useMemo(() => [verifications, {
    requestVerifications: handleRequestVerifications,
    deleteVerificationBySolutionId,
  }], [
    verifications,
    handleRequestVerifications,
    deleteVerificationBySolutionId,
  ]);

  return memoizedResult;
}
